import { useCallback, useContext } from 'react';
import { flushSync } from 'react-dom';
import type {
  InstrumentType,
  TranscriptionDialogContextValue,
} from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { TranscriptionDialogContext } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { useWizard } from './WizardContext';

export function useNextStepAfterUpdate() {
  const { next } = useWizard();
  const { setSettings } = useContext(TranscriptionDialogContext);

  return useCallback(
    (patch: Parameters<typeof setSettings>[0], instrument?: InstrumentType) => {
      flushSync(() => {
        setSettings(patch as Partial<TranscriptionDialogContextValue['settings']>, instrument);
      });
      Promise.resolve().then(() => {
        next();
      });
    },
    [setSettings, next],
  );
}
